import { ArtistState } from './state';
import { blankArtistPage } from './blank-artist-page';

export const artistInitialState: ArtistState = {
  myArtists: [],
  search: [],
  activeTeam: [],
  loaded: false,
  achievements: [],
  externalIdValidation: {
    externalId: '',
    validationResult: false,
  },
  artistPage: blankArtistPage(),
};
